
import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/logo.png";
import {
  Container,
  Navbar,
  Nav,
  NavDropdown,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "../Header/header.css";
import { useAuth } from "../../../context/AuthContext";

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const { user, logout } = useAuth();

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    const header = document.querySelector(".header-section");
    const scrollTop = window.scrollY;
    scrollTop >= 120
      ? header.classList.add("is-sticky")
      : header.classList.remove("is-sticky");
  };

  const closeMenu = () => {
    if (window.innerWidth <= 991) {
      setExpanded(false);
    }
  };

  return (
    <>
      {/* ✅ Sticky Top Bar */}
      <div className="top-bar-wrapper position-sticky top-0 z-1030">
        <div className="top-bar text-white py-2 fade-in">
          <Container>
            <div className="contact-info small d-flex justify-content-end flex-wrap align-items-center gap-4">
              {/* Call Us */}
              <div className="d-flex align-items-center gap-2">
                <strong className="text-danger">Call us:</strong>
                <i className="fas fa-phone-alt text-danger"></i>
                <span className="text-black">+91 76006 68600</span>
                <i className="fas fa-phone-alt text-danger ms-3"></i>
                <span className="text-black">+91 91730 05554</span>
              </div>

              {/* Location */}
              <div className="d-flex align-items-center gap-2">
                <strong className="text-danger">Location:</strong>
                <i className="fas fa-map-marker-alt text-danger"></i>
                <span className="text-black">Surat, Gujarat</span>
              </div>
            </div>
          </Container>
        </div>
      </div>



      {/* ✅ Main Header/Navbar */}
      <header className="header-section bg-white shadow-sm">
        <Container>
          <Navbar
            expand="lg"
            className="p-0 d-flex justify-content-between align-items-center"
            expanded={expanded}
            style={{ minHeight: "50px" }}
          >
            {/* Logo */}
            <Navbar.Brand
              as={NavLink}
              to="/"
              className="me-4 d-flex align-items-center"
            >
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: "90px",
                  objectFit: "contain",
                  marginTop: "-40px",
                  marginBottom: "-66px",
                }}
              />
            </Navbar.Brand>

            {/* Toggle Button */}
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={() => setExpanded(!expanded)}
            />

            {/* Nav Links */}
            <Navbar.Collapse
              id="basic-navbar-nav"
              className="justify-content-end"
            >
              <Nav className="">
                <NavLink className="nav-link" to="/" onClick={closeMenu}>
                  Home
                </NavLink>
                <NavLink className="nav-link" to="/blogs" onClick={closeMenu}>
                  Blogs
                </NavLink>
                <NavLink
                  className="nav-link"
                  to="/about-us"
                  onClick={closeMenu}
                >
                  About Us
                </NavLink>
                <NavLink className="nav-link" to="/tours" onClick={closeMenu}>
                  Tours
                </NavLink>
                <NavDropdown title="Destination" id="destination-dropdown">
                  <NavLink
                    className="dropdown-item"
                    to="/destinations"
                    onClick={closeMenu}
                  >
                    India Tours
                  </NavLink>
                </NavDropdown>
                <NavLink
                  className="nav-link"
                  to="/gallery"
                  onClick={closeMenu}
                >
                  Gallery
                </NavLink>
                <NavLink
                  className="nav-link"
                  to="/contact-us"
                  onClick={closeMenu}
                >
                  Contact
                </NavLink>

                {/* Auth Links */}
                {!user ? (
                  <NavLink
                    className="nav-link text-danger"
                    to="/admin-login"
                    onClick={closeMenu}
                  >
                    Admin Login
                  </NavLink>
                ) : (
                  <>
                    <NavLink
                      className="nav-link text-success"
                      to="/admin-dashboard"
                      onClick={closeMenu}
                    >
                      Admin Dashboard
                    </NavLink>
                    <span
                      className="nav-link text-danger"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        logout();
                        closeMenu();
                      }}
                    >
                      Logout
                    </span>
                  </>
                )}
              </Nav>
            </Navbar.Collapse>
          </Navbar>

        </Container>

      </header>

    </>
  );
};

export default Header;
